export const productReducer = (
  state = {
    categories: [],
    readCategoriesLoading: false,

    singleCategory: {},
    readSingleCategoryLoading: false,

    createCategoryLoading: false,
    updateCategoryLoading: false,

    createSubcategoryLoading: false,
    updateSubcategoryLoading: false,

    products: [],
    readProductsLoading: false,

    singleProduct: {},
    readSingleProductLoading: false,

    createProductLoading: false,
    updateProductLoading: false,
    deleteProductLoading: false,

    bulkImportLoading: false,
    bulkImportResult: null,

    bulkUploadHistory: [],
    bulkUploadHistoryMeta: {},
    bulkUploadHistoryLoading: false,
  },
  action
) => {
  switch (action.type) {
    // Categories
    case "READING_PRODUCT_CATEGORIES":
      return { ...state, readCategoriesLoading: true };
    case "GOT_PRODUCT_CATEGORIES":
      return { ...state, readCategoriesLoading: false, categories: action.payload };
    case "CANNOT_GET_PRODUCT_CATEGORIES":
      return { ...state, readCategoriesLoading: false };

    case "READING_SINGLE_PRODUCT_CATEGORY":
      return { ...state, readSingleCategoryLoading: true };
    case "GOT_SINGLE_PRODUCT_CATEGORY":
      return { ...state, readSingleCategoryLoading: false, singleCategory: action.payload };
    case "CANNOT_GET_SINGLE_PRODUCT_CATEGORY":
      return { ...state, readSingleCategoryLoading: false };

    case "CREATING_PRODUCT_CATEGORY":
      return { ...state, createCategoryLoading: true };
    case "PRODUCT_CATEGORY_CREATED":
      return { ...state, createCategoryLoading: false };
    case "CANNOT_CREATE_PRODUCT_CATEGORY":
      return { ...state, createCategoryLoading: false };

    case "UPDATING_PRODUCT_CATEGORY":
      return { ...state, updateCategoryLoading: true };
    case "PRODUCT_CATEGORY_UPDATED":
      return { ...state, updateCategoryLoading: false };
    case "CANNOT_UPDATE_PRODUCT_CATEGORY":
      return { ...state, updateCategoryLoading: false };

    // Subcategories
    case "CREATING_PRODUCT_SUBCATEGORY":
      return { ...state, createSubcategoryLoading: true };
    case "PRODUCT_SUBCATEGORY_CREATED":
      return { ...state, createSubcategoryLoading: false };
    case "CANNOT_CREATE_PRODUCT_SUBCATEGORY":
      return { ...state, createSubcategoryLoading: false };

    case "UPDATING_PRODUCT_SUBCATEGORY":
      return { ...state, updateSubcategoryLoading: true };
    case "PRODUCT_SUBCATEGORY_UPDATED":
      return { ...state, updateSubcategoryLoading: false };
    case "CANNOT_UPDATE_PRODUCT_SUBCATEGORY":
      return { ...state, updateSubcategoryLoading: false };

    // Products
    case "READING_PRODUCTS":
      return { ...state, readProductsLoading: true };
    case "GOT_PRODUCTS":
      return { ...state, readProductsLoading: false, products: action.payload };
    case "CANNOT_GET_PRODUCTS":
      return { ...state, readProductsLoading: false };

    case "READING_SINGLE_PRODUCT":
      return { ...state, readSingleProductLoading: true };
    case "GOT_SINGLE_PRODUCT":
      return { ...state, readSingleProductLoading: false, singleProduct: action.payload };
    case "CANNOT_GET_SINGLE_PRODUCT":
      return { ...state, readSingleProductLoading: false };

    case "CREATING_PRODUCT":
      return { ...state, createProductLoading: true };
    case "PRODUCT_CREATED":
      return { ...state, createProductLoading: false };
    case "CANNOT_CREATE_PRODUCT":
      return { ...state, createProductLoading: false };

    case "UPDATING_PRODUCT":
      return { ...state, updateProductLoading: true };
    case "PRODUCT_UPDATED":
      return { ...state, updateProductLoading: false };
    case "CANNOT_UPDATE_PRODUCT":
      return { ...state, updateProductLoading: false };

    case "DELETING_PRODUCT":
      return { ...state, deleteProductLoading: true };
    case "PRODUCT_DELETED":
      return {
        ...state,
        deleteProductLoading: false,
        products: Array.isArray(state.products)
          ? state.products.filter((p) => p._id !== action.payload)
          : state.products,
      };
    case "CANNOT_DELETE_PRODUCT":
      return { ...state, deleteProductLoading: false };

    case "BULK_IMPORTING_PRODUCTS":
      return { ...state, bulkImportLoading: true, bulkImportResult: null };
    case "BULK_IMPORTED_PRODUCTS":
      return { ...state, bulkImportLoading: false, bulkImportResult: action.payload };
    case "CANNOT_BULK_IMPORT_PRODUCTS":
      return { ...state, bulkImportLoading: false };

    case "READING_BULK_UPLOAD_HISTORY":
      return { ...state, bulkUploadHistoryLoading: true };
    case "GOT_BULK_UPLOAD_HISTORY":
      return {
        ...state,
        bulkUploadHistoryLoading: false,
        bulkUploadHistory: action.payload?.history || [],
        bulkUploadHistoryMeta: {
          total: action.payload?.total || 0,
          page: action.payload?.page || 1,
          limit: action.payload?.limit || 20,
          totalPages: action.payload?.totalPages || 1,
        },
      };
    case "CANNOT_GET_BULK_UPLOAD_HISTORY":
      return { ...state, bulkUploadHistoryLoading: false };

    default:
      return state;
  }
};
